import ReactDOM from 'react-dom';
import 'src/mocks';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import ScrollTop from 'src/hooks/useScrollTop';

import 'nprogress/nprogress.css';
import { Provider } from 'react-redux';
import store from 'src/store';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import { AuthProvider } from 'src/contexts/JWTAuthContext';
import { I18nextProvider } from 'react-i18next';

import './css/index.css';
import './css/font.css';
import containerI18n from './i18n/i18n';

ReactDOM.render(
  <HelmetProvider>
    <Provider store={store}>
      <I18nextProvider i18n={containerI18n}>
        <SidebarProvider>
          <BrowserRouter
            basename={window.__RUNTIME_CONFIG__?.REACT_APP_CONTEXT_PATH}
          >
            <ScrollTop />
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </SidebarProvider>
      </I18nextProvider>
    </Provider>
  </HelmetProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
